var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"footer-text"},[_c('p',[_vm._v("地址：广东省广州市天河区科华街251号乐天创意园B3006")]),_c('p',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("粤ICP备14033869号")]),_vm._v(" ©2020-2030 广州松冬体育信息咨询有限公司")])])])
}]

export { render, staticRenderFns }